<script>
import Layout from "../../layouts/main";
import VehicleMakeList from "./vehicle-make-list.vue";
import VehicleModelList from "./vehicle-model-list.vue";
import BatterySizeList from "./battery-size-list.vue";
import ChargerTypeList from "./charger-type-list.vue";
import { mapGetters, mapActions } from "vuex";
import appConfig from "@/app.config";
export default {
  page: {
    title: "Vehicle Management",
    meta: [{ name: "description", content: appConfig.description }],
  },
  name: "user-details",
  data() {
    return {};
  },
  components: {
    Layout,
    VehicleMakeList,
    VehicleModelList,
    BatterySizeList,
    ChargerTypeList,
  },
  computed: mapGetters([]),
  methods: {
    ...mapActions([]),
  },
  mounted() {},
};
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left d-flex align-items-center">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-tag"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">Vehicle Management</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted" lazy>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Vehicle Make</span>
                </template>
                <VehicleMakeList />
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Vehicle Model</span>
                </template>
                <VehicleModelList />
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Charger Type</span>
                </template>
                <ChargerTypeList />
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Battery Size</span>
                </template>
                <BatterySizeList />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.page-title-box {
  padding-bottom: 24px;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4 {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px !important;
}
.icon-main-page .page-title-left {
  display: flex;
  align-items: center;
}
.avatar-main-icon .avatar-xs {
  margin-top: -20px;
}
</style>
